import * as React from 'react';
import styled from 'styled-components';

import RewardCategory from '../../lib/types/RewardCategory';

interface IProps {
  rewardCategory: RewardCategory;
  onClick: () => void;
  className?: string;
}

function UnstyledRewardCategoryItem(props: IProps) {
  return (
    <button onClick={props.onClick} className={props.className}>
      <img src={props.rewardCategory.imageUrl} />
      <span>{props.rewardCategory.name}</span>
    </button>
  );
}

const RewardCategoryItem = styled(UnstyledRewardCategoryItem)`
  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    width: 5rem;
    height: 5rem;

    object-fit: contain;
  }

  span {
    padding: 1rem;
    font-size: 1rem;
  }
`;

export default RewardCategoryItem;



// WEBPACK FOOTER //
// ./src/components/RewardCategoryList/RewardCategoryItem.tsx